import React from 'react';
import { Alert } from 'reactstrap';

const CaseTabNotImplemented = () => {
  return (
    <div>
      <Alert color="danger">
        <span>Kartica nije implementirana.</span>
      </Alert>
    </div>
  );
};

export default CaseTabNotImplemented;
